import { createRouter, createWebHashHistory } from 'vue-router'
import celebrationView from '@/views/celebrationView.vue'
import PhoneView from '@/views/phoneView.vue'
import PhotoView from '@/views/photoView.vue'
import SpinView from '@/views/spinView.vue'
import { useCheckLink } from '@/composables/checkLink'
import { useParticipationStore } from '@/stores/useParticipationStore'

const routes = [
  {
    path: '/participation/:code',
    name: 'participation',
    children: [

      {
        path: 'photo',
        name: 'photo',
        component: PhotoView
      },
      {
        path: 'spin',
        name: 'spin',
        component: SpinView
      },
      {
        path: 'felicitations',
        name: 'celebration',
        component: celebrationView
      }
    ]
  },
  {
    path: '/participation/',
    name: 'phone',
    component: PhoneView
  }
  ,
  {
    path: '/test',
    name: 'test',
    component: PhotoView
  },
]

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes
})


router.beforeEach(async (to, from, next) => {

  const participationStore = useParticipationStore();
  const { verifyLink } = useCheckLink();
  const protectedRoutes = ["photo", "spin", "celebration"];

  if (to.name === "test") {
    return next();
  }

  if (to.name === "phone") {
    if (!participationStore.link || !participationStore.participation) {
      return next();
    }

    return next(determineCorrectRoute(participationStore, participationStore.participation));
  }

  const linkVerification = await verifyLink(to);

  if (!linkVerification.success) {
    return next({ name: "phone" });
  }

  const participation = linkVerification.participation;
  const isProtectedRoute = protectedRoutes.includes(to.name);


  if (!isProtectedRoute) {
    return next(determineCorrectRoute(participationStore, participation));
  }



  if (to.name === "photo") {
    if (participation.bottle_photo) {
      return next({
        name: "spin",
        params: { code: participationStore.link }
      });
    }
    return next();
  }

  if (to.name === "spin") {
    if (!participation.bottle_photo) {
      return next({
        name: "photo",
        params: { code: participationStore.link }
      });
    }

    if (participation.gift_id !== null) {
      return next({
        name: "celebration",
        params: { code: participationStore.link }
      });
    }

    return next();
  }

  if (to.name === "celebration") {
    if (participation.gift_id === null) {
      return next({
        name: "spin",
        params: { code: participationStore.link }
      });
    }

    return next();
  }

  next();
});

function determineCorrectRoute(participationStore, participation) {
  const code = participationStore.link;

  if (!participation.bottle_photo) {
    return { name: "photo", params: { code } };
  }

  if (participation.gift_id === null) {
    return { name: "spin", params: { code } };
  }

  return { name: "celebration", params: { code } };
}


export default router